import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, ProfileApi, SendCodeResponse, SendCodeToMobileRequest } from '@shared/api';

interface UseSendCodeToMobileStore {
  data: SendCodeResponse | null;
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  send: (request: SendCodeToMobileRequest) => void;
  clear: () => void;
}

export const useSendCodeToMobileStore = create<UseSendCodeToMobileStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  success: null,

  send: async (request: SendCodeToMobileRequest) => {
    try {
      set({ loading: true, data: null, error: null, success: null });
      const result = await ProfileApi.sendCodeToMobile(request);
      set({ loading: false, data: result, success: true });
      return { loading: false, data: result, success: true };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null, success: null }),
}));
